"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedOptionIndex = exports.useEventListener = void 0;
var React = require("react");
var useEventListener = function (eventName, handler) {
    var savedHandler = React.useRef();
    React.useEffect(function () {
        savedHandler.current = handler;
    }, [handler]);
    React.useEffect(function () {
        var eventListener = function (event) { return savedHandler.current(event); };
        document.addEventListener(eventName, eventListener);
        return function () {
            document.removeEventListener(eventName, eventListener);
        };
    }, [eventName]);
};
exports.useEventListener = useEventListener;
var getSelectedOptionIndex = function (defaultOptionIndex, placeholder, optionsLength) {
    if (defaultOptionIndex !== undefined &&
        defaultOptionIndex !== null &&
        defaultOptionIndex >= 0 &&
        optionsLength &&
        defaultOptionIndex < optionsLength) {
        return defaultOptionIndex;
    }
    if (!placeholder) {
        return 0;
    }
    return -1;
};
exports.getSelectedOptionIndex = getSelectedOptionIndex;
